import variableColors from "@/base/global/variables/figma.colors.json";

export const layoutThemeToken: any = {
  //============================ COLORS ============================//
  bodyBg: variableColors["ColorFigmaNeutralWhiteWhite100"],
  footerBg: variableColors["ColorFigmaNeutralWhiteWhite100"],
  headerBg: variableColors["ColorFigmaComplementaryBlue50"],

  //============================ SIZE ============================//
  headerHeight: 64,
};
